import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class AstatDailyLocalTaxInfo {
  @MappedProperty()
  month: number;

  @MappedProperty()
  monthClosed: boolean;

  @MappedProperty()
  totalArrivals: number;

  @MappedProperty()
  totalDepartures: number;

  @MappedProperty()
  totalGuestsPresent: number;

  @MappedProperty()
  totalTaxAdults: number;

  @MappedProperty()
  totalTaxChildren: number;

  @MappedProperty()
  totalTaxExempted: number;

  @MappedProperty()
  year: number;

  constructor(init?: Partial<AstatDailyLocalTaxInfo>) {
    Object.assign(this, init);
  }
}
